import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 403 && cfg.url.startsWith("/admin") && String(err.response?.data?.detail).includes("revoked")
        && window.location.pathname !== "/admin/login") {
      window.location.assign("/admin/login");
    }
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.includes("auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post(cfg.url.startsWith("/admin") ? "/admin-auth/refresh" : "/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fmt = (v, dg = 5) => (v == null || Number.isNaN(v) ? "—" : Number(v).toFixed(dg));
export const money = (v, ccy = "USD") =>
  v == null ? "—" : new Intl.NumberFormat("en-US", { style: "currency", currency: ccy, maximumFractionDigits: 2 }).format(v);
export const pairId = (s) => s.replace("/", "");
export const timeAgo = (iso) => {
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
};
